<template>
  <div class="index" @click="goNext()" v-bind:style="{backgroundImage:'url(' + bg_img + ')'}">
      <h3 class="title animated bounceInLeft"><span>企业发展</span></h3>
      <h3 class="animated bounceInLeft">我们正在成长…</h3>
      <div ref="content" class="font bottom animated bounceInLeft">
        <div><span>40个 </span> 主要城市</div>
        <div style="font-size:0.24rem;letter-spacing:2px"><span>800+ </span> 公寓楼</div>
        <div style="font-size:0.30rem;letter-spacing:3px"><span>12万 </span> 床位数</div>
        <div style="font-size:0.36rem;margin-top:0.1rem;letter-spacing:4px" class="animated fadeIn"><span>团队 </span> 不断壮大</div>
        <div style="font-size:0.42rem;margin-top:0.2rem;letter-spacing:5px" class="animated fadeIn"><span>专业度 </span> 不断提升</div>
      </div>
      <img class="index-bottom" src="https://cdn.hanlandglobal.com/h5-grow-bg2.png" />
      <img ref="gif" class="gif-img animated fadeIn" :src="gif" /> 
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/grow-bg.jpg'
import button_img from '../assets/image/button-bg.png'
import gif from '../assets/image/shouzhi.gif'

export default {
  name: 'Home',
  data(){
    return {
      bg_img,
      button_img,
      gif
    }
  },
  mounted(){

  },
  methods:{
    goNext(){
      this.$router.push('/service')
    }
  }
}
</script>
<style lang='scss' scoped>
.index{
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
.title{
    padding-top:13.6vh;
}
h3{
  font-size: 0.36rem;
  font-family: SourceHan;
  color: #4d372e;
  text-align: left;
  letter-spacing: 1px;
  margin-left: 1.3rem;
  span{
    font-size: 0.64rem;

  }
}
.index-bottom{
  width: 100%;
  height: calc(100vh - 5.2rem);
  height: -webkit-calc(100vh - 5.2rem);
  max-height: 8.2rem;
  position: absolute;
  left: 0;
  bottom: 0; 
}
.button-bg{
  width: 2rem;
  height: 0.62rem;
  background-repeat: no-repeat;
  background-size: 2rem 0.62rem;
  margin:0 auto;
  color: #f8eed5;
  font-size: 0.32rem;
  line-height: 0.62rem;
  margin-top: 1.34rem;
  font-weight: 700;
  font-family: SourceHan;
}
.font{
    font-family: SourceHanSansCN-Regular;
	font-size: 0.16rem;
	font-weight: bold;
	letter-spacing: 1px;
	color: #543f3c;
  text-align: left;
  margin-left: 1.3rem;
    span{
        font-family: SourceHanSansCN-Bold;
        display: inline-block;
        font-weight: bold;
        letter-spacing: 3px;
        color: #f67869;
    }
}
.bottom{
    margin-top: 0.6rem;
    line-height: 0.56rem;
}
.gif-img{
  position:absolute;
  width: 2.7rem;
  height: 1.98rem;
  z-index: 999;
  bottom: 3rem;
  right: 1rem;
  animation-delay: 0.8s; 
}
</style>
